import { HeaderGrid } from '../DesktopNavigation/styles';

export const SkeletonNavigation = () => {
  return <HeaderGrid className="sticky top-0 z-50 bg-white h-header print:hidden" />;
};
